/**
 * Imperative escape hatch for publishing walkthrough context from code that
 * cannot use hooks (antd column builders, event handlers in plain helpers).
 * The provider registers its `publishContext`; without a provider the calls
 * are no-ops.
 */
let publisher = null;

export function registerContextPublisher(fn) {
    publisher = fn;
    return () => {
        if (publisher === fn) publisher = null;
    };
}

export function publishWalkthroughContext(partial) {
    if (publisher) publisher(partial);
}
